import { noop, partial, isString } from 'underscore';
import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import { getDomain } from '@bingads-webui/url-util';

import { Error } from './error';
import { withError } from './with-error';
import { BaseTextField } from './base-text-field';
import { containerStyles, contentStyles } from '../styles';

const Path1Field = withError(BaseTextField, 'Path1');
const Path2Field = withError(BaseTextField, 'Path2');
const DisplayUrlField = withError(BaseTextField, 'DisplayUrl');
export function UrlPath(props) {
  const {
    config,
    value,
    url,
    i18n,
    onChange,
    IsVanityUrlEnabled,
    DisplayUrl,
  } = props;
  const [Path1, Path2] = value;

  const urlDomain = useMemo(() => getDomain(url), [url]);

  const onTextChange = useCallback((path, newValue) => {
    onChange(newValue, path);
  }, [onChange]);

  return (
    <Stack className="url-path" tokens={contentStyles.errorStackToken}>
      <Stack
        horizontal
        verticalAlign="baseline"
        styles={containerStyles.urlPath}
        tokens={contentStyles.pathFieldStackToken}
      >
        {
          IsVanityUrlEnabled ?
            <DisplayUrlField
              configProps={config.DisplayUrl}
              value={DisplayUrl || ''}
              updateItem={partial(onTextChange, 'DisplayUrl')}
              i18n={i18n}
            /> :
            <div className="display-url-text">
              {isString(urlDomain) && urlDomain.length > 0 ?
                urlDomain :
                'www.example.com'
              }
            </div>
        }
        <div className="url-separator">/</div>
        <Path1Field
          configProps={config.Path1}
          value={Path1}
          updateItem={partial(onTextChange, 'Path1')}
          i18n={i18n}
          optional
        />
        <div className="url-separator">/</div>
        <Path2Field
          configProps={config.Path2}
          value={Path2}
          updateItem={partial(onTextChange, 'Path2')}
          i18n={i18n}
          optional
        />
      </Stack>
      <Error property="DisplayUrl" />
      <Error property="Path1" />
      <Error property="Path2" />
    </Stack>
  );
}

UrlPath.propTypes = {
  config: PropTypes.shape({
  }).isRequired,

  value: PropTypes.arrayOf(PropTypes.string).isRequired,

  url: PropTypes.string.isRequired,

  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,

  onChange: PropTypes.func,

  IsVanityUrlEnabled: PropTypes.bool,

  DisplayUrl: PropTypes.string,
};

UrlPath.defaultProps = {
  onChange: noop,
  IsVanityUrlEnabled: false,
  DisplayUrl: '',
};
